var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#4A148C"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }